import styled from 'styled-components';

interface Props {
  isHome?: boolean,
}


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${(props: Props) => props.isHome ? '-140px' : 0};
  z-index: 100;

  @media only screen and (max-width: 767px) {
    margin-top: ${(props: Props) => props.isHome ? '-120px' : 0};
  }
`;

const Description = styled.div`
  padding: 40px 0;
  width: 90%;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 10px;
`;

const Content = styled.p`
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 40px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column; 
  width: 100%;
  
  &:not(:last-child) {
    margin-bottom: 25px;
  }
`;

const Label = styled.p`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
  color: #333;
`;

const Input = styled.input`
  height: 62px;
  background: #fff;
  color: #333;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0 , .1);
  border: 0;
  outline: 0;
  padding: 5px 18px;
  border-radius: 4px;
  -webkit-appearance: none;

  &::placeholder {
    color: #a3a3a3;
  }
`;

const TextArea = styled.textarea`
  height: 200px;
  background: #fff;
  color: #333;
  font: inherit;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0 , .1);
  border: 0;
  outline: 0;
  padding: 22px 18px;
  border-radius: 4px;
  line-height: 1.5;
  resize: none;
  -webkit-appearance: none;

  &::placeholder {
    color: #a3a3a3;
  }
`;

const Button = styled.button`
  background: #05D6E1;
  border-radius: 4px;
  width: 100%;
  height: 60px;
  border: 0;
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  color: #333;

  &:hover, &:focus {
    box-shadow: 1px 5px 15px rgba(0, 0, 0, 0.2);
  }
`;

export {
  Wrapper,
  Title,
  Content,
  Description,
  InputWrapper,
  Label,
  Input,
  TextArea,
  Button,
};
